import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import ProductForm from '../components/products/ProductForm';
import productService from '../services/productService';
import categoryService from '../services/categoryService';
import { Link } from 'react-router-dom';
import { Spin } from 'antd';
import { Category } from '../types/categories';
import { useSnackbar } from 'notistack';

const ProductCreate: React.FC = () => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        const res = await categoryService.getCategories();
        setCategories(res.data);
      } catch (err) {
        enqueueSnackbar('Không thể tải danh mục', { variant: 'error' });
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, [enqueueSnackbar]);

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      console.log('create product data:', data);
      await productService.createProduct(data);
      enqueueSnackbar('Tạo sản phẩm thành công!', { variant: 'success' });
      navigate('/admin/products');
    } catch (err) {
      enqueueSnackbar('Tạo sản phẩm thất bại!', { variant: 'error' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className='p-6'>
      <div className='mb-6'>
        <Link
          to='/admin/products'
          className='inline-flex items-center text-blue-600 hover:text-blue-800'
        >
          <ArrowLeftIcon className='mr-1 w-4 h-4' />
          <span>Quay lại danh sách sản phẩm</span>
        </Link>
        <h1 className='mt-4 text-2xl font-semibold text-gray-900'>
          Thêm sản phẩm mới
        </h1>
        <p className='mt-1 text-sm text-gray-500'>
          Tạo một sản phẩm mới cho cửa hàng của bạn.
        </p>
      </div>
      {loading ? (
        <Spin />
      ) : (
        <ProductForm
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/products')}
          isSubmitting={isSubmitting}
          categories={categories}
        />
      )}
    </div>
  );
};

export default ProductCreate;
